import { Box, ButtonBase } from "@mui/material";
import emailConfigurationsStyles from "../EmailConfigurations.styles";

const styles = emailConfigurationsStyles;

interface EmailConfigSwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  /** Announced to assistive tech — the visible label sits beside the control. */
  label: string;
  disabled?: boolean;
  id?: string;
}

/**
 * The design's 40×23 pill switch. `CustomSwitch` draws the app's older, larger
 * track, and it is still used by every screen that has not been re-skinned yet,
 * so this stays screen-scoped until the tokens are promoted globally.
 */
const EmailConfigSwitch = ({
  checked,
  onChange,
  label,
  disabled = false,
  id,
}: EmailConfigSwitchProps) => (
  <ButtonBase
    id={id}
    disableRipple
    role="switch"
    aria-checked={checked}
    aria-label={label}
    disabled={disabled}
    onClick={() => onChange(!checked)}
    sx={styles.toggle(checked)}
  >
    <Box component="span" sx={styles.toggleKnob(checked)} />
  </ButtonBase>
);

export default EmailConfigSwitch;
